<template>
  <el-dialog :append-to-body="true" id="upload-sign-layer" title="添加签章" :visible.sync="dialogVisible" width="434px" :show-close="true" :center="true">
    <el-form @submit.native.prevent :model="uploadForm" label-width="80px" :rules="uploadRules" ref="uploadForm" class="upload-Form">
      <el-form-item label="签章名" prop="signName">
        <el-input maxlength="10" v-model="uploadForm.signName" placeholder="请输入签章名"></el-input>
      </el-form-item>
      <el-form-item label="上传图样" prop="signFile">
        <div class="upload-sign">
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="myHeaders"
            list-type="picture-card"
            :on-preview="handleSealPreview"
            :before-upload="handleSealBeforeUpload"
            :on-success="handleSealSuccess"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="uploadVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>
      </el-form-item>
    </el-form>
    <p class="upload-tip">格式为JPG、JPEG、PNG，大小不超过5MB</p>

    <div class="upload-btns">
      <el-button type="primary" :disabled="clickUpload" @click="uploadSealHandle" class="upload-btn">上传签章</el-button>
      <el-button type="info" @click="cancel" class="upload-btn">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils/auth'
import { uploadSealApi } from '@/api/space/signatures'
import { mapState } from 'vuex'
export default {
  computed: mapState([
    'currentSpace'
  ]),
  data() {
    return {
      uploadUrl: ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API)+'sealInfo/uploadSealFile',
      myHeaders: {
        'Authorization': getToken()
      },
      clickUpload: false,
      dialogImageUrl: '',
      uploadVisible: false,
      dialogVisible: false,
      uploadForm: {
        signName: '',
        signFile: ''
      },
      uploadRules: {
        signName: [
          { required: true, message: '签章名不能为空！', trigger: 'blur' }
        ],
        signFile: [
          { required: true, message: '请上传图样！', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleSealPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSealSuccess(response, file, fileList) {
      this.uploadForm.signFile = response.result.sealData
    },
    uploadSealHandle() {
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          this.clickUpload = true
          uploadSealApi({
            type: '1',
            data: this.uploadForm.signFile,
            sealName: this.uploadForm.signName,
            id: this.currentSpace.companyId
          }).then(res => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'warning'
              });
              this.clickUpload = false
            } else {
              this.$message({
                showClose: true,
                message: '上传成功！',
                type: 'success'
              });
              this.cancel()
              this.$parent.getCompanySealInfoHandle()
              this.clickUpload = false
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })

    },
    cancel() {
      this.uploadForm.signName = ''
      this.dialogVisible = false
      this.$refs.upload.clearFiles();
    },
    handleSealBeforeUpload(file) {
      if (file.type == 'image/png' || file.type == 'image/jpeg' || file.type == 'image/jpg') {
      } else {
        this.$message.warning(`图片类型不正确，请重新上传图片！`);
        return false
      }

      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning(`图片大小超出限制，请重新上传图片！`);
        return false
      }
    }
  }
}
</script>
<style scoped>
  .upload-sign{
    width: 148px;
    height: 148px;
    overflow: hidden;
    position: relative;
  }

  .upload-tip{
    font-size: 14px;
    color: #999999;
    margin: -10px 0 0 70px;
  }

  .upload-btns{
    width: 383px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }

  .upload-btns button {
    display: block;
    width: 179px;
    height: 50px;
    font-size: 18px;
    border-radius: 10px;
  }
</style>
